var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"message"},[_c('i',{staticClass:"material-icons"},[_vm._v("gps_off")]),_c('span',[_vm._v(_vm._s(_vm.$t('errors.notFound')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }